import _ from "underscore";
import { removeById } from "@exovera/helpers";

// flattenList
// removeChildren
// isAncestorActive
// proxyDeselection
// addAncestors
// getOtherSiblings

// Returns a flat array of objects, with name, id, children, and parent fields
// 	 - flattens elements in the field 'children' recursively
// NOTE: Does not mutate nestedList
export const flattenList = (params) => {
	const { nestedList } = params;

	let flatList = [];

	_.each(nestedList, (obj) => {
		flatList = [
			{
				name: obj.name,
				id: obj.id,
				parent: obj.parent,
				children: obj.children && JSON.parse(JSON.stringify(obj.children)),
			},
			...flatList,
		];
		if (obj.children) {
			flatList = [...flattenList({ nestedList: obj.children }), ...flatList];
		}
	});

	return flatList;
};

// removes all children & grandchildren from the selected arrayr
//	array - Array of Objects. Must have field "id"
//	childName - name of array (not required) owned by parent
//	parent - Object - will remove parent[childname] from array
export const removeChildren = (params) => {
	const { array, childName, parent } = params;

	let noDescendants = array ? JSON.parse(JSON.stringify(array)) : false;

	if (noDescendants && childName && parent) {
		_.each(parent[childName], (child) => {
			noDescendants = removeById({ array: noDescendants, id: child.id });
			if (child[childName]) {
				noDescendants = removeChildren({ array: noDescendants, childName, parent: child });
			}
		});
	}
	return noDescendants;
};

// Returns the oldest anscestor on selected if active contains an ancestor of selected
// NOTE: this assumes that only one anscestor is active
//	active: Array of Objects. Must have field "id"
//  selected: Object. Must have field "id" and "parent"
// 	familyTree - Arrray of Objects. Flat array of all options
export const isAncestorActive = (params) => {
	const { familyTree, active, selected } = params;

	let activeAncestor = false;

	// no active ancestors if nothing is active
	if (!active) {
		return false;
	}

	// find direct parent of selected
	const parent = _.find(familyTree, (obj) => {
		return obj.id === selected.parent;
	});

	// Return the first active parent you find
	if (parent) {
		const parentActive = !!_.find(active, (obj) => {
			return obj.id === parent.id;
		});
		if (parentActive) {
			activeAncestor = parent;
		} else {
			activeAncestor = isAncestorActive({ familyTree, active, selected: parent });
		}
	}

	return activeAncestor;
};

// Removes activeAncestor from array AND adds all descendants to array that aren't directly related to deselect
//	array: Array of Objects. Must have field "id"
//	activeAncestor: Object
//  deselect: Object. Must have field "id" and "parent"
// 	familyTree - Arrray of Objects. Flat array of all options
export const proxyDeselection = (params) => {
	const { activeAncestor, array, childName, deselect, familyTree } = params;
	// remove activeAncestor from array
	let activatedArray = removeById({ array, id: activeAncestor.id }) || [];

	// make a list of select's ancestors to activeAncestor - these will not be active
	const deactivatedArr = addAncestors({
		child: deselect,
		list: [deselect],
		stopId: activeAncestor.id,
		familyTree,
	});

	// activate first children of activeAncestor that are not or do not contain deselect
	const updatedList =
		getOtherSiblings({
			list: deactivatedArr,
			siblings: activeAncestor[childName],
			stopId: deselect.id,
			childName,
		}) || [];

	activatedArray = [...updatedList, ...activatedArray];

	return activatedArray;
};

// Adds any anscestors to list, until stop is reached
//	list: array
// 	familyTree - Arrray of Objects. Flat array of all options
//	stopId: string or number. Id of the object you do not want included
//	child: Object looking for it's parent in familyTree
export const addAncestors = (params) => {
	const { child, familyTree, list, stopId } = params;
	let updatedList = list;

	// Stop when you hit the stopId - that object will not be added
	if (child.parent !== stopId) {
		const parent = _.find(familyTree, (obj) => {
			return obj.id === child.parent;
		});
		if (parent) {
			// Keep adding ancestors until you can't find a parent or the stopId is hit
			updatedList = addAncestors({
				child: parent,
				list: [...updatedList, parent],
				stopId,
				familyTree,
			});
		}
	}

	return updatedList;
};

// Returns an array of all siblings that are not on the list
export const getOtherSiblings = (params) => {
	const { list, childName, siblings, stopId } = params;

	if (!siblings || !Array.isArray(siblings)) {
		console.warn(
			"Siblings must be an array or getOtherSiblings will fail. siblings = ",
			siblings,
			Array.isArray(siblings)
		);
	}

	let allowedSiblings = [];

	const deactivatedSibling = _.find(list, (obj) => {
		return _.find(siblings, (child) => {
			return obj.id === child.id;
		});
	});

	// Should not happen
	if (!deactivatedSibling) {
		allowedSiblings = siblings;
	} else {
		allowedSiblings =
			deactivatedSibling.id !== stopId
				? [
						...getOtherSiblings({
							list,
							siblings: deactivatedSibling[childName],
							stopId,
							childName,
						}),
						..._.filter(siblings, (sib) => {
							return sib.id !== deactivatedSibling.id;
						}),
				  ]
				: _.filter(siblings, (sib) => {
						return sib.id !== stopId;
				  });
	}

	return allowedSiblings;
};
